export default __webpack_public_path__ + "static/media/step-1-of-4.9d3918e9.gif";